import React from 'react';
import { shape, string, object } from 'prop-types';
import { Link, useStaticQuery, graphql } from 'gatsby';

import ImageLogo from '../ImageLogo';
import SafeGatsbyImage from '../SafeGatsbyImage';
import { renderPhoneNumber } from '../../lib/renderHelper';

import * as styles from './header.module.css';

const Header = ({ data }) => {
  const { title, baseline, phoneNumber, phoneNumberTarget, logo = {} } = data;
  const { label: phoneNumberLabel = '', value: phoneNumberValue = '' } = renderPhoneNumber(phoneNumber);

  return (
    <header className="header">
      <div className="container">
        <div className={styles.headerRow}>
          <div className={styles.partenaire}>
            <Link to="/" title={title}>
              <SafeGatsbyImage itemProp="logo" image={logo} style={{ marginRight: '10px' }} />
            </Link>
            <div>
              <div itemProp="name" className={styles.name}>
                {title}
              </div>
              <span itemProp="slogan">{baseline}</span>
            </div>
          </div>

          <div className={styles.buttonGroup}>
            {phoneNumberValue && (
              <a
                itemProp="telephone"
                href={`tel:${phoneNumberValue}`}
                className={`btn btn-two btn-md ${styles.mr2}`}
                title="Nous telephoner"
              >
                {phoneNumberLabel}
              </a>
            )}
            <Link className="btn btn-two btn-md" title="Nous contacter" to="/nous-contacter/">
              Nous contacter
            </Link>
          </div>

          <div className={styles.perge}>
            <a href="https://www.perge.com" title="PERGE">
              <ImageLogo />
            </a>
            Installateur partenaire
          </div>
        </div>
      </div>
    </header>
  );
};

Header.propTypes = {
  data: shape({ title: string, baseline: string, phoneNumber: string, logo: object }),
};

Header.defaultProps = { data: { title: '', baseline: '', phoneNumber: '', logo: {} } };

export default Header;
